/* eslint-disable import/prefer-default-export */

export const getBorder = (theme, args = {}) => {
  const {
    all,
    top,
    bottom,
    left,
    right,
    color = theme.palette.grey[300],
    width = 1,
    borderStyle = 'solid',
  } = args;
  const borderConfig = `${width}px ${borderStyle} ${color}`;
  if (all) return { border: borderConfig };

  const res = {};
  if (top) res.borderTop = borderConfig;
  if (bottom) res.borderBottom = borderConfig;
  if (left) res.borderLeft = borderConfig;
  if (right) res.borderRight = borderConfig;

  return res;
};

export const getLightBorder = (theme, args = {}) => {
  return getBorder(theme, { ...args, color: theme.palette.facet.lightGray });
};

export const getBorderRadius = (radius, positions) => {
  const {
    all,
    top,
    bottom,
    right,
    left,
    topLeft,
    topRight,
    bottomLeft,
    bottomRight,
  } = positions;

  const res = {};

  if (all) return { borderRadius: radius };
  if (top || left || topLeft) res.borderTopLeftRadius = radius;
  if (top || right || topRight) res.borderTopRightRadius = radius;
  if (bottom || left || bottomLeft) res.borderBottomLeftRadius = radius;
  if (bottom || right || bottomRight) res.borderBottomRightRadius = radius;

  return res;
};
